import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'src/app/home/services/user.service';

@Component({
  selector: 'app-delete-user-modal',
  standalone: true,
  imports: [],
  templateUrl: './delete-user-modal.component.html',
  styleUrls: ['./delete-user-modal.component.scss', '../../../app.component.scss', '../../../shared/base-modal.style.scss']
})
export class DeleteUserModalComponent {
  public dialogData: any;

  constructor(
    public dialogRef: MatDialogRef<DeleteUserModalComponent>,
    public dialog: MatDialog,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if(data){
      this.dialogData = data;
    }
  }

  submit(){
    this.userService.deleteUser(this.dialogData.userId).subscribe({
      next: (res) => {
        if (res.data) {
          this.dialogRef.close({ status: true, message: 'User has been deleted successfully'});
        }else{
          this.dialogRef.close({ status: false, message: "Oops something went wrong."});
        }
      },
      error: (error) => {
        if (error) {
          this.dialogRef.close({ status: false, message: "Oops something went wrong."});
        }
      },
      complete: () => {return} 
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
